import graymotif from "../../assets/graymotif.svg";
import darkarrow from "../../assets/dark-arrow.svg";
import { Link } from "react-router-dom";
import { Mixpanel } from "../../helpers/mixpanel";
import React, { useState } from "react";

function HeroTest() {
  const [showVideo, setShowVideo] = useState(false);

  const handleWatchVideo = () => {
    Mixpanel.track("CLICKED WATCH VIDEO");
    setShowVideo(true);
  };

  const openChatWidget = () => {
    Mixpanel.track("CLICKED AI ASSISTANT HELP");
    const chatWidget = document.querySelector('chat-widget');
    if (chatWidget && chatWidget.shadowRoot) {
      const chatButton = chatWidget.shadowRoot.querySelector('button');
      if (chatButton) { chatButton.click(); return; }
    }
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen relative bg-hero bg-cover w-full text-white">
      <div className="h-24 lg:h-28"></div>

      <div className="pt-8 xl:pt-12 pb-20">
        <div className="flex flex-col mx-auto justify-center items-center text-center px-4">

          <div className="mb-8">
            <div className="bg-orange text-dark py-2 px-6 font-semibold text-sm md:text-base inline-flex items-center gap-2 rounded-full shadow-lg">
              <span>Complete a quote and receive a <strong>$25 Amazon credit</strong> — takes under 60 seconds</span>
            </div>
          </div>

          <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight">
            Enterprise Fiber Quotes
            <br />
            <span className="text-orange">in 60 Seconds</span>
          </h1>

          <p className="mt-4 lg:mt-6 text-lg lg:text-xl text-blue2">
            Compare carriers. See real pricing. <strong>No sales calls.</strong>
          </p>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-blue2">
            <span className="flex items-center gap-2">
              <span className="text-green-400">&#10003;</span> 15+ national carriers
            </span>
            <span className="flex items-center gap-2">
              <span className="text-green-400">&#10003;</span> 25M+ business addresses
            </span>
            <span className="flex items-center gap-2">
              <span className="text-green-400">&#10003;</span> Instant pricing
            </span>
          </div>

          <div className="mt-8 sm:mt-10">
            <Link to="/app/pick-mechanism">
              <button
                className="cta cta-hover uppercase bg-orange border-orange text-dark text-base px-8 py-4 font-bold"
                onClick={() => Mixpanel.track("CLICKED GET QUOTE")}
              >
                CHECK AVAILABILITY{" "}
                <img alt="arrow" src={darkarrow} />
              </button>
            </Link>
          </div>

          <p className="mt-4 text-xs text-blue2 opacity-75">
            No commitment required &bull; Receive a $25 Amazon credit for completing a quote
          </p>

          <div className="mt-8 bg-white bg-opacity-10 rounded-xl p-4 max-w-md" style={{border: 'none', boxShadow: 'none'}}>
            <p className="text-white text-sm mb-3">
              <strong>Two ways to get your quote:</strong>
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center">
              <Link to="/app/pick-mechanism">
                <button
                  className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-full text-sm transition-all"
                  style={{border: 'none'}}
                  onClick={() => Mixpanel.track("CLICKED DO IT YOURSELF")}
                >
                  &#128640; Self-service quote
                </button>
              </Link>
              <span className="text-blue2 text-xs">or</span>
              <button
                className="bg-orange text-dark px-4 py-2 rounded-full text-sm font-semibold hover:bg-opacity-90 transition-all flex items-center gap-2"
                style={{border: 'none'}}
                onClick={openChatWidget}
              >
                &#128172; Chat with AI Assistant
              </button>
            </div>
          </div>

          <button
            onClick={handleWatchVideo}
            className="mt-6 flex items-center gap-3 text-white hover:text-orange transition-colors group"
            style={{border: 'none'}}
          >
            <span className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center group-hover:bg-opacity-30 transition-colors">
              <svg className="w-5 h-5 ml-1" fill="currentColor" viewBox="0 0 20 20">
                <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
              </svg>
            </span>
            <span className="text-base">See how it works (30 sec)</span>
          </button>

          <div className="mt-8 bg-white bg-opacity-10 rounded-lg p-5 max-w-lg mx-4" style={{border: 'none'}}>
            <p className="text-white text-base italic">
              "Got our quote in under a minute. Saved 40% switching from AT&amp;T."
            </p>
            <p className="text-blue2 mt-2 text-sm">&mdash; Tech Company, Dallas TX</p>
          </div>

          <div className="flex justify-center gap-8 md:gap-16 mt-10 max-w-xl w-full px-4">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-orange">60s</div>
              <div className="text-xs md:text-sm text-blue2">Avg quote time</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-orange">30%</div>
              <div className="text-xs md:text-sm text-blue2">Avg savings</div>
            </div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-orange">99.999%</div>
              <div className="text-xs md:text-sm text-blue2">Uptime SLA</div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 -mb-14 sm:-mb-28 flex w-full justify-center">
        <img src={graymotif} alt="motif" className="opacity-0" />
      </div>

      {showVideo && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
          onClick={() => setShowVideo(false)}
        >
          <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="relative bg-black rounded-lg overflow-hidden" style={{paddingTop: "56.25%"}}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube.com/embed/YOUR_VIDEO_ID?autoplay=1"
                title="How FiberFed Finder Works"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <button
              onClick={() => setShowVideo(false)}
              className="mt-4 text-white hover:text-orange flex items-center gap-2"
              style={{border: 'none'}}
            >
              <span>&#10005;</span> Close video
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default HeroTest;
